import Constants from "../utils/consts";
import Utils from "../utils/utils";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function addPropostaRecupero(
  username,
  token,
  id_corso_proposto,
  label_corso_proposto,
  id_lezione_proposta,
  label_lezione_proposta,
  id_richiesta_recupero,
  note_recupero = "", // Parametro opzionale per le note
  id_sessione = null // ✅ AGGIUNTO: Parametro opzionale per id_sessione (mezze giornate)
) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "addPropostaRecupero.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);
        const bodyString = body.toString();
        console.log("Raw response from addPropostaRecupero:", bodyString);

        if (!bodyString.trim()) {
          console.error("Empty response from server");
          resolve({
            result: "error",
            message: "Server returned empty response",
          });
          return;
        }

        try {
          const resp = JSON.parse(bodyString);
          resolve(resp);
        } catch (parseError) {
          console.error("JSON parse error:", parseError);
          console.error("Response body:", bodyString);
          resolve({
            result: "error",
            message: "Invalid JSON response from server",
          });
        }
      });

      res.on("error", function(error) {
        console.error(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: username,
      id_corso_proposto: id_corso_proposto,
      label_corso_proposto: label_corso_proposto,
      id_lezione_proposta: id_lezione_proposta,
      label_lezione_proposta: label_lezione_proposta,
      id_richiesta_recupero: id_richiesta_recupero,
      note_recupero: note_recupero || "", // Aggiungo le note al payload
      id_sessione: id_sessione, // ✅ AGGIUNTO: Include id_sessione nel payload
    });

    console.log("[addPropostaRecupero] POST data being sent:", postData);
    console.log(
      "[addPropostaRecupero] id_sessione value:",
      id_sessione,
      "type:",
      typeof id_sessione
    );

    req.write(postData);

    req.end();
  });
}
